import React from 'react';

const Contact: React.FC = () => {
  return (
    <div>
      
    </div>
  );
};

export default Contact;


